import { render, staticRenderFns } from "./invitationTask.vue?vue&type=template&id=52275e78&scoped=true&"
import script from "./invitationTask.vue?vue&type=script&lang=js&"
export * from "./invitationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52275e78",
  null
  
)

export default component.exports